import { render, staticRenderFns } from "./ChangeLogShow.vue?vue&type=template&id=1f0fe76a&"
import script from "./ChangeLogShow.vue?vue&type=script&lang=js&"
export * from "./ChangeLogShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports